import { useCallback } from 'react';
import useAnalyticsContext from '|/hooks/use-analytics-context';

export const useDigitalWalletsEventTracking = () => {
  const { trackEvent } = useAnalyticsContext();

  return useCallback(
    (eventName: string, eventProperties?: Record<string, unknown>) => {
      trackEvent(`pp_complete_purchase_digital_wallet_${eventName}`, eventProperties);
    },
    [trackEvent]
  );
};
